import React, { useContext } from 'react'
import SidebarContext from '../../context/SidebarContext'

import ArrowImage from '../../assets/images/OP_Portal_Arrow_White_RT.svg'

const Sidebar = ({ children }) => (
    <div id="section-side">
        <div id="side-content">{children}</div>
    </div>
)

const SidebarToggle = ({ children }) => {
    const { sidebarOpen, setSidebar } = useContext(SidebarContext)
    return (
        <div id="section-side" className={sidebarOpen ? null : 'side-closed'}>
            <img
                id="side-toggle"
                onClick={() => setSidebar(!sidebarOpen)}
                src={ArrowImage}
                alt="toggle sidebar"
            />
            <div id="section-side-content">{children}</div>
        </div>
    )
}

const MainContent = ({ children }) => (
    <div id="section-content" className="page-wrapper page-content">
        {children}
    </div>
)

export { Sidebar, MainContent, SidebarToggle }
